export const formatDuration = (l, precision) => {
    precision = precision || 'seconds';

    var delta = Math.abs(l);

    var d = Math.floor(delta / 86400);
    delta -= d * 86400;

    var h = Math.floor(delta / 3600) % 24;
    delta -= h * 3600;

    var m = Math.floor(delta / 60) % 60;
    delta -= m * 60;

    var s = Math.floor(delta) % 60;


    if (d > 365 * 10)
        return '';

    else {
        var result = [];

        if (d > 0) {
            result = [
                d + 'д',
                h + 'ч',
                m + 'м',
                s + 'с'
            ];
        } else if (h > 0) {
            result = [
                h + 'ч',
                m + 'м',
                s + 'с'
            ];
        } else if (m > 0) {
            result = [
                m + 'м',
                s + 'с'
            ];
        } else {
            result = [
                s + 'с'
            ];
        }

        if (precision === 'hours') {
            result.pop();
            result.pop();

        } else if (precision === 'minutes') {
            result.pop();

        } else {

        }

        if (result.length > 0) {
            return result.join(' ');

        } else {
            if (precision === 'hours') {
                return '0ч';

            } else if (precision === 'minutes') {
                return '0м';

            } else {
                return '0с';
            }
        }
    }
}
